export const cancelOrderAdapter = (trxId, pharmacy) => {
	return {
		trx_id: trxId?.toString(),
		pharmacy: pharmacy,
		status: '008',
	};
};
